import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SnackBarService } from '@shared/services/snack-bar.service';
import { catchError, EMPTY, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SensitivityLevel } from '@shared/models/sensitivity-level.model';
import { GENERAL_ERROR_MESSAGE } from '@shared/models/messages';

@Injectable()
export class SensitivityLevelApiService {
  readonly http = inject(HttpClient);
  private readonly _messageService = inject(SnackBarService);
  readonly url = `${environment.apiUrl}/sensitivity-levels`;

  getSensitivityLevels$(): Observable<SensitivityLevel[]> {
    return this.http.get<SensitivityLevel[]>(`${this.url}`).pipe(
      catchError(error => {
        this._messageService.showError(`Failed to retrieve sensitivity levels: ${error.error.message ?? GENERAL_ERROR_MESSAGE}.`);
        return EMPTY;
      })
    );
  }
}
